import { useCallback, useRef } from 'react'
import AppStore from '@v4/store/appStore'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import { validateEmailAdvance } from '@v4/utils/validations'
import { useResultInitialAnswers, useSignUpData } from '../Form.hooks'
import { formatAnalyticData, formatErrors, formatValues } from '../Form.utils'

export const useChangeEmailForm = ({
	placeholderColor,
	title,
	titleConfig,
	buttonText,
	usePaperColors,
	className,
	classes,
	fieldsPerRow,
	onSuccess,
	onTitleClick,
	onButtonClick,
	titleEditable,
	onTitleChange,
	buttonTextEditable,
	buttonTextConfig,
	onButtonTextChange,
	titleKey,
	buttonTextKey,
}) => {
	const captchaRef = useRef(null)
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const updateSingUp = AppStore.useStoreActions(actions => actions.signUp.updateSingUp)
	const pageId = PageBuilderSelector.usePageId()
	const initialAnswers = useResultInitialAnswers()

	const { data, settings, formikProps } = useSignUpData(initialAnswers)

	const advancedEmailValidation = settings.advanced_email_validation

	const handleFormSubmit = useCallback(
		async (values, formikBag) => {
			if (isBuilderMode) return {}
			let captcha

			const emailError = await validateEmailAdvance(values.email, advancedEmailValidation)

			if (emailError) {
				formikBag.setErrors({ email: emailError })
				return undefined
			}

			if (captchaRef.current) {
				const { response } = await captchaRef.current.execute({ async: true })
				captcha = response
			}

			const formValues = formatValues(values)
			const analyticData = formatAnalyticData(formValues, data)

			return updateSingUp({ pageId, values: { ...(captcha && { captcha }), ...formValues }, analyticData })
				.then(onSuccess)
				.catch(err => {
					formikBag.setErrors(formatErrors(err))
				})
		},
		[advancedEmailValidation, data, isBuilderMode, onSuccess, pageId, updateSingUp],
	)

	return [
		{
			data,
			settings,
			formikProps,
			placeholderColor,
			title,
			buttonText,
			usePaperColors,
			className,
			classes,
			fieldsPerRow,
			titleEditable,
			titleConfig,
			buttonTextEditable,
			buttonTextConfig,
			titleKey,
			buttonTextKey,
			captchaRef,
			withCaptcha: true,
		},
		{
			handleFormSubmit,
			handleTitleClick: onTitleClick,
			handleButtonClick: onButtonClick,
			handleTitleChange: onTitleChange,
			handleButtonTextChange: onButtonTextChange,
		},
	]
}
